import { Box, LinearProgress, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

type UploadProgressProps = {
  isUploading: boolean;
  progress: number; // 0-100
  message?: string;
};

const UploadProgress = ({
  isUploading,
  progress,
  message = "Uploading video...",
}: UploadProgressProps) => {
  if (!isUploading) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#f5f5f5",
        padding: "16px 24px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CloudUploadIcon
          sx={{
            color: "#1976d2",
            fontSize: 28,
          }}
        />
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: "#333",
              }}
            >
              {message}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#1976d2",
              }}
            >
              {Math.round(progress)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 6,
              borderRadius: 3,
              backgroundColor: "#e0e0e0",
              "& .MuiLinearProgress-bar": {
                borderRadius: 3,
                backgroundColor: "#1976d2",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UploadProgress;
